import apiClient from './index'

export default {
  csrf () {
    return apiClient.get('/auth/csrf-cookie')
  },
  login (credentials) {
    return apiClient.post('/auth/login', credentials)
  },
  check () {
    return apiClient.get('/auth/check')
  },
  logout () {
    return apiClient.post('/auth/logout')
  }
}
